export default "__VITE_ASSET__oNK4B69y__"